module.exports = __webpack_public_path__ + "static/media/test-kit-half-block.95556b95.png";